const TOKEN_KEY = 't'
const REFRESH_TOKEN_KEY = 'rt'
const LATEST_ADDRESS_JSON_STRINGIFY = 'lajs'

export const LocalStorageKeys = {
    TOKEN_KEY,
    REFRESH_TOKEN_KEY,
    LATEST_ADDRESS_JSON_STRINGIFY,
}
